import { render } from "./CadastrarLoja.vue?vue&type=template&id=08d2803c&scoped=true"
import script from "./CadastrarLoja.vue?vue&type=script&lang=js"
export * from "./CadastrarLoja.vue?vue&type=script&lang=js"

import "./CadastrarLoja.vue?vue&type=style&index=0&id=08d2803c&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d2803c"]])

export default __exports__